import { BatchClassConfig } from "./config/BatchClassConfig";
import { BatchClassRoleStore } from "../stores/impl/BatchClassRoleStore";
import { RoleStore } from "../stores/impl/RoleStore";
import { BatchClassMetadataData } from "./config/BatchClassMetadata";

class RealRolePermissionclass {
  _checkRolePermissions: undefined | boolean;
  constructor() {}
  cantSeeRolePermissions(): void {
    this._checkRolePermissions = true;
  }

  canSeeRolePermissions(): boolean {
    if (this._checkRolePermissions == undefined) return true;
    return this.evalCanSeeRolPerms();
  }

  evalCanSeeRolPerms(): boolean {
    return (
      RoleStore.getAll()
        .map((r) => r.roleManagement)
        .filter(Boolean).length > 0
    );
  }

  canSeeBccMigration(): boolean {
    // return true;
    return (
      RoleStore.getAll()
        .map((r) => r.batchClassMigration)
        .filter(Boolean).length != 0
    );
  }

  canSeeBatchMigration(
    batchClass?: BatchClassConfig | BatchClassMetadataData,
  ): boolean {
    const stores = [];
    if (batchClass) {
      stores.push(BatchClassRoleStore.getBatchClassStore(batchClass));
    } else {
      stores.push(...BatchClassRoleStore.getAllStores());
    }
    return (
      stores
        .flatMap((store) => store.getAll().map((r) => r.batchMigration))
        .filter(Boolean).length != 0
    );
  }

  canSeeModelMigration(
    batchClass?: BatchClassConfig | BatchClassMetadataData,
  ): boolean {
    const stores = [];
    if (batchClass) {
      stores.push(BatchClassRoleStore.getBatchClassStore(batchClass));
    } else {
      stores.push(...BatchClassRoleStore.getAllStores());
    }
    return (
      stores
        .flatMap((store) => store.getAll().map((r) => r.modelMigration))
        .filter(Boolean).length != 0
    );
  }

  canRolesEditBcc(
    batchClass?: BatchClassConfig | BatchClassMetadataData,
  ): boolean {
    const stores = [];
    if (batchClass) {
      stores.push(BatchClassRoleStore.getBatchClassStore(batchClass));
    } else {
      stores.push(...BatchClassRoleStore.getAllStores());
    }
    return (
      stores
        .flatMap((store) => store.getAll().map((r) => r.editBatchClassSettings))
        .filter(Boolean).length != 0
    );
  }
}

export { RealRolePermissionclass };

const RealRolePermission = new RealRolePermissionclass();

export default RealRolePermission;
